<div class="profile-container" fxLayout="column" fxLayoutAlign="center stretch">

  <!-- Header -->
  <div fxLayout="row" fxLayoutAlign="space-between center" class="header-bar">
    <span class="user-profile-text">User Profile</span>
  </div>
  @if(userData) {
  <!-- Profile Section -->
  <div fxLayout="row" fxLayoutGap="24px" fxLayoutAlign="start start" class="profile-section">
    @if(showAvatar) {
    <img src="assets/images/profile-avtar.png" 
         class="avatar" 
         alt="User Profile"
         (error)="onImageError()" />
    }

    <div fxFlex class="profile-info">
      <p class="user-profile-name">{{ userData?.firstName }} {{userData?.lastName}}</p>
      <p class="user-profile-label">Login ID: {{ userData.upn }}</p>
      @if(userData.parentOrg) {
      <p class="user-profile-label">
        Organization:
        <button type="button" (click)="redirectToOrgProfile()" class="link-button">{{ userData.parentOrg.name }}</button>
      </p>
      @let formattedAddress = getFormattedAddress();
      @if(formattedAddress) {
      <p class="user-profile-label address">{{ formattedAddress }}</p>
      }
      }
      <p class="user-profile-label">Application Role: {{ userData.userRoles }}</p>
    </div>
  </div>

  <!-- Tabs -->
  <div style="margin-top: 32px;">
    <mat-tab-group>
      <mat-tab label="Contact Information">
        <div fxLayout="column" fxLayoutGap="16px" class="contact-info">
          <p class="user-profile-label">Primary Phone* {{ userData.phone }}</p>
          <p class="user-profile-label">Secondary Phone* {{ userData.mobile || '—' }}</p>
          <p class="user-profile-label">
            Email Address*
            <a href="mailto:{{ userData.email }}"> {{ userData.email }}</a>
          </p>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  }


</div>